import { render, staticRenderFns } from "./ConfirmAccountForm.vue?vue&type=template&id=a2d919b8&"
import script from "./ConfirmAccountForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports